import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import { getTranslationKey } from '../../../modules/utils/helpers';

interface Survey {
  score: number;
}

interface Surveys {
  nps?: Survey;
  ces?: Survey;
}

interface SurveyModalNPSProps {
  isSurveyModalNPSOpen: boolean;
  surveys?: Surveys;
  setSurveyModalNPSVisibility: (isOpen: boolean) => void;
}

const SurveyModalNPS: React.FC<SurveyModalNPSProps> = ({
  isSurveyModalNPSOpen,
  setSurveyModalNPSVisibility,
  surveys
}) =>
  isSurveyModalNPSOpen ? (
    <Modal
      centered
      isOpen={isSurveyModalNPSOpen}
      toggle={() => setSurveyModalNPSVisibility(!isSurveyModalNPSOpen)}
      wrapClassName="modal-dark"
      size="lg"
      backdrop="static"
    >
      <ModalHeader toggle={() => setSurveyModalNPSVisibility(!isSurveyModalNPSOpen)}>
        {getTranslationKey('surveys.ces.modalTitle')}
      </ModalHeader>
      <ModalBody className="min-h-500">
        <iframe
          className="min-h-500"
          title="survey-frame"
          id="typeform-full"
          width="100%"
          height="100%"
          frameBorder="0"
          allow="camera; microphone; autoplay; encrypted-media;"
          src={`https://scrappbook.typeform.com/to/vWlY10${
            surveys && surveys.nps && surveys.nps.score >= 0
              ? `?prefilled_answer=${surveys.nps.score}`
              : ''
          }`}
        />
      </ModalBody>
    </Modal>
  ) : null;

interface RootState {
  message: {
    isSurveyModalNPSOpen: boolean;
  };
  auth: {
    surveys?: Surveys;
  };
}

function mapStateToProps({ message: { isSurveyModalNPSOpen }, auth: { surveys } }: RootState) {
  return {
    isSurveyModalNPSOpen,
    surveys
  };
}

export default connect(mapStateToProps, actions)(SurveyModalNPS);
